import { useAppSelector } from '../hooks';
import { getBrand, getParkId, getParkUri, getIsInPark, getLat, getLng } from '../slices/appSlice';

export const useAppState = () => {
  return {
    brand: useAppSelector(getBrand),
    parkId: useAppSelector(getParkId),
    parkUri: useAppSelector(getParkUri),
    isInPark: useAppSelector(getIsInPark),
    lat: useAppSelector(getLat),
    lng: useAppSelector(getLng),
  };
};
